import React, { Component } from 'react'
import Header from "../profile/Header"
import CalendarWidget from "../event/CalendarWidget"
import axios from 'axios'
import {getUserFromLocalStorage} from "../../helper/helpingFunctions"
import { thisTypeAnnotation } from '@babel/types'
import { yearsToQuarters } from 'date-fns'
// import { timeStamp } from 'console'

///IF USER wants to save days when he is free for parituclar activity. use localstorage with eventId AS THE key to store that info.
export default class Singleeventpage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            ...props.location.state,
            user: getUserFromLocalStorage()
        }

        this.handleEvent = this.handleEvent.bind(this)
    }

    componentDidMount() {
        
    }

    componentDidUpdate(prevProps, prevState, snapshot) { if (prevState.name !== this.state.name) { this.handler() } }

    componentWillUnmount() {
        
    }

    // Prototype methods, Bind in Constructor (ES2015)
    handleEvent() {}

    getUserInfoFromLocalStorage() {
        let user = getUserFromLocalStorage()
        if(user.daysFree[this.state.id]) {
            return user.daysFree[this.state.id]
        }
        return null
    }

    // Class Properties (Stage 3 Proposal)
    handler = () => { this.setState() }
    onSubmit = async(daysFreeFromCal) => {
        let eventFromDb;
        let {id} = this.state

        let user = getUserFromLocalStorage();
        try {
            eventFromDb = await axios.post(process.env.REACT_APP_API + "/events/get-one", {id:id});
        }catch(error) {
            console.log(error);
        }finally {
            let fetchedFreeDaysFromDB = eventFromDb.data.daysFree
            let daysNeedToBeDeleted,daysNeedToBeAdded
            daysNeedToBeAdded = daysFreeFromCal

            if(id in user.daysFree) {
                daysNeedToBeDeleted = removeDuplicatesFromMap(user.daysFree[id], daysFreeFromCal) 
                Object.entries(daysNeedToBeDeleted).map(([key]) => {
                    if(key in fetchedFreeDaysFromDB) {
                        let freeDayFromDB = fetchedFreeDaysFromDB[key];
                        if(freeDayFromDB.indexOf(user._id) !== -1) {
                            freeDayFromDB.splice(freeDayFromDB.indexOf(user._id), 1)
                        }
                        fetchedFreeDaysFromDB[key] = freeDayFromDB;
                    }
                    return null
                })
            }

            Object.entries(daysNeedToBeAdded).map(([key]) => {
                if(key in fetchedFreeDaysFromDB) {
                    let freeDayFromDB = fetchedFreeDaysFromDB[key];
                    if(!freeDayFromDB.includes(user._id)) {
                        freeDayFromDB.push(user._id)
                    } 
                } else {
                    fetchedFreeDaysFromDB[key] = [user._id]
                }
            })

            //function to loop throught databse.data.daysfree and delete days with no users.
            Object.entries(eventFromDb.data.daysFree).map(([key]) => {
                if(eventFromDb.data.daysFree[key].length <= 0) {
                    delete eventFromDb.data.daysFree[key]
                }
            })
            user.daysFree[id] = daysNeedToBeAdded
            localStorage.setItem("user", JSON.stringify(user))
            await axios.post(process.env.REACT_APP_API + "/users/update-user", {user: user})
            await axios.post(process.env.REACT_APP_API + "/events/update-event", {event: eventFromDb.data})
            return window.location.reload();

        }


    }
    render() {
        return (
            <>
                <Header />
                <CalendarWidget onSubmit={this.onSubmit} eventId={this.state.id} daysFree={this.getUserInfoFromLocalStorage()}/>
                {/* <div className="best-days">
                    
                </div> */}
            </>
        )
    }
}


function removeDuplicatesFromMap(givenMap, mapNeedsTOclean) {
    let newMap = {}
    Object.entries(givenMap).map(([key, value]) => {
        if(!(key in mapNeedsTOclean)) {
            newMap[key] = true
        }
    })
    return newMap;
}
